/* src/app/add-edit-experience-modal/add-edit-experience-modal.component.scss */
.wc-form-control.nobg {
  border: 1px solid #d9d9d9;
  padding: 4px 10px;
  height: 30px;
  border-radius: 2px;
  font-weight: normal;
}
.h-105 {
  height: 105px !important;
}
.topright1 {
  top: 5px;
  background-color: #ffffff;
  z-index: 0;
  right: 5px;
  padding: 0 10px 0 0;
  color: #2e93a1;
}
.nobg.border-red {
  border: 1px solid #dc3545;
}
button.close {
  opacity: 1;
  line-height: 1;
  color: #484b59;
  font-size: 14px;
}
.position-relative select.nobg {
  appearance: none;
  -webkit-appearance: none;
  z-index: 1;
}
.wc-checkbox {
  width: 15px !important;
  height: 15px !important;
}
.wc-checkbox input[type=checkbox] {
  width: 15px !important;
  height: 15px !important;
}
@media only screen and (max-width: 1440px) {
  .wc-checkbox {
    width: 15px !important;
    height: 15px !important;
  }
  .wc-checkbox input[type=checkbox] {
    width: 15px !important;
    height: 15px !important;
  }
}
@media only screen and (max-width: 1368px) {
  .wc-checkbox {
    width: 15px !important;
    height: 15px !important;
  }
  .wc-checkbox input[type=checkbox] {
    width: 15px !important;
    height: 15px !important;
  }
}
@media only screen and (max-width: 1170px) {
  .wc-checkbox {
    width: 15px !important;
    height: 15px !important;
  }
  .wc-checkbox input[type=checkbox] {
    width: 15px !important;
    height: 15px !important;
  }
}
/*# sourceMappingURL=add-edit-experience-modal.component-ZQCLIHRP.css.map */
